import BankEdit from '@/components/bank/edit/BankEdit.vue'

export default {
  name: 'BankPicker',
  props: ['value', 'disabled', 'disableAdd'],
  data () {
    return {
      content: this.value,
      itemOptions: null,
      searchTxt: '',
      currentReq: null,
      loading: false
    };
  },
  components: {
    BankEdit
  },
  computed: {
    canEdit () {
      if (this.disableAdd) {
        return false;
      }
      return this.ApiRequest.userHasPermission('edit-settings') && !this.disabled;
    },
    hasAnyResults () {
      return this.itemOptions && this.searchTxt && this.searchTxt.length > 0 && this.itemOptions.length === 0;
    }
  },
  methods: {
    updateValue () {
      this.$emit('input', this.content)
    },
    searchItem () {
      if (this.currentReq) {
        this.currentReq.cancel('changed search query');
      }
      this.loading = true;
      this.content = null;
      this.updateValue();
      const self = this;
      let search = this.searchTxt;
      if (search.indexOf('[') >= 0) {
        search = search.substring(0, search.indexOf('['));
      }
      this.currentReq = this.ApiRequest.request('bank/find?qry=' + search, this.ApiRequest.REQUEST_GET, [], function (response) {
        if (response.data) {
          self.itemOptions = response.data;
          self.loading = false;
        }
      });
    },
    getItemText (item) {
      if (item) {
        return item.name + ' [' + item.swift + ']';
      }
      return '';
    },
    selectItem (item) {
      this.searchTxt = this.getItemText(item);
      this.content = item;
      this.updateValue();
      this.itemOptions = null;
      this.loading = false;
    },
    clearSearch () {
      this.itemOptions = null;
      this.searchTxt = '';
      this.content = null;
      this.loading = false;
      this.updateValue();
    },
    editElement (refName, element) {
      this.$refs[refName].show(element);
    }
  },
  mounted () {
    this.searchTxt = this.getItemText(this.content);
  }
}
